import { useDeal } from '../../hooks/useDeal';
import { IdentityCard } from './IdentityCard';
import { FilesList } from './FilesList';
import { TitleFindingsList } from './TitleFindingsList';

interface Props { dealId: string; }

export function LeftColumn({ dealId }: Props) {
  const { deal, data } = useDeal(dealId);
  if (!deal) return <aside className="col-left"></aside>;
  return (
    <aside className="col-left">
      <IdentityCard deal={deal} />
      <FilesList dealId={dealId} files={data.files} />
      <TitleFindingsList dealId={dealId} findings={data.findings} />
    </aside>
  );
}
